/**
 * Phase 6 settings (Settings → Offline & displays). Each choice is a setting; these defaults are
 * the recommended ones. The offline time limit itself (72 h) is a platform setting in the admin
 * portal, and offline billing never runs past the subscription's expiry date.
 */
export const KITCHEN_TIMING = Object.freeze([
  { key: 'after_payment', label: 'After the cashier takes payment' },
  { key: 'immediately', label: 'As soon as the customer orders' },
]);

export const DEFAULT_DEVICE_SETTINGS = Object.freeze({
  offline: {
    enabled: true, // registered billing devices keep selling when the internet drops
    invoiceFormat: '{DEVICE}/{FY}/{SEQ6}', // separate series per device, so numbers never collide
    allowNewCustomers: true, // phone + name kept on the bill; the customer is created when it syncs
    allowCredit: false, // putting bills on credit needs the customer's live balance
    allowHolds: true, // hold orders and send them to the kitchen offline (tickets print / local screens)
    allowUserSwitching: true, // staff switch with their PIN offline, checked on this device
    userSwitchDays: 14, // ...if they signed in here online with that PIN within this many days
    localKitchen: true, // offline kitchen tickets also go to kitchen screens on this PC / print agent
  },
  kds: {
    warnMinutes: 8, // ticket turns amber
    lateMinutes: 15, // ticket turns red
    sound: true, // chime on a new ticket
    hideServedAfterMinutes: 2, // "recall" list keeps served tickets this long
  },
  display: {
    enabled: true,
    showPreparing: true, // "Preparing" column next to "Ready for pickup"
    readyMinutes: 10, // a ready token leaves the board after this long (or when collected)
    chime: true,
  },
  selfOrder: {
    payAtCounter: true,
    payByUpi: true, // customer scans the UPI QR; the cashier confirms the payment
    kitchen: 'after_payment', // KOT when the cashier takes payment (or 'immediately')
    orderTypes: ['takeaway', 'dine_in'],
    idleSeconds: 60, // back to the welcome screen after this much inactivity
    autoCancelMinutes: 30, // unpaid self-orders (not yet in the kitchen) are cancelled
    welcomeText: 'Tap to order',
  },
});

/** Kitchen ticket colours by age (minutes since the KOT). */
export function ticketUrgency(createdAt, now, { warnMinutes, lateMinutes }) {
  const mins = (new Date(now) - new Date(createdAt)) / 60_000;
  return mins >= lateMinutes ? 'late' : mins >= warnMinutes ? 'warn' : 'ok';
}
